import CustomFieldService from "../services/customField.service";

export default {
  name: "customField",
  fn: (value, customField) => {
    return CustomFieldService.renderValue(customField, value);
  }
};
